<template>
<div class="chapter">
<div class="inner_page">
<p class="sp-brk2"> </p>
<p class="fmh">CONTENTS</p>
<p class="toc"><span href="#/xhtml/001_dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="toc-bot"><a href="#/xhtml/001_title#tit">The Gift of Fire</a></p>
<p class="toc-pn"><a href="#/xhtml/001_part1#pt1">Part One</a></p>
<p class="toc"><a href="#/xhtml/001_prologue#pro">Prologue</a></p>
<p class="toc"><a href="#/xhtml/001_chapter1#ch1">Chapter 1</a></p>
<p class="toc"><a href="#/xhtml/001_chapter2#ch2">Chapter 2</a></p>
<p class="toc"><a href="#/xhtml/001_chapter3#ch3">Chapter 3</a></p>
<p class="toc"><a href="#/xhtml/001_chapter4#ch4">Chapter 4</a></p>
<p class="toc"><span href="#/xhtml/001_chapter5#ch5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc"><span href="#/xhtml/001_chapter6#ch6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc"><span href="#/xhtml/001_chapter7#ch7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc"><span href="#/xhtml/001_chapter8#ch8" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc-bot1"><span href="#/xhtml/001_chapter9#ch9" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc-pn"><span href="#/xhtml/001_part2#pt2" title="Link target outside of Sample">Part II</span></p>
<p class="toc"><span href="#/xhtml/001_chapter10#ch10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc"><span href="#/xhtml/001_chapter11#ch11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc"><span href="#/xhtml/001_chapter12#ch12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc"><span href="#/xhtml/001_chapter13#ch13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc"><span href="#/xhtml/001_chapter14#ch14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc"><span href="#/xhtml/001_chapter15#ch15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc"><span href="#/xhtml/001_chapter16#ch16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="toc-bot1"><span href="#/xhtml/001_chapter17#ch17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="toc-pn"><span href="#/xhtml/001_part3#pt3" title="Link target outside of Sample">Part III</span></p>
<p class="toc"><span href="#/xhtml/001_chapter18#ch18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="toc"><span href="#/xhtml/001_chapter19#ch19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="toc"><span href="#/xhtml/001_chapter20#ch20" title="Link target outside of Sample">Chapter 20</span></p>
<p class="toc"><span href="#/xhtml/001_chapter21#ch21" title="Link target outside of Sample">Chapter 21</span></p>
<p class="toc"><span href="#/xhtml/001_chapter22#ch22" title="Link target outside of Sample">Chapter 22</span></p>
<p class="toc"><span href="#/xhtml/001_chapter23#ch23" title="Link target outside of Sample">Chapter 23</span></p>
<p class="toc-bot"><span href="#/xhtml/001_epilogue#epil" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc-bot"><span href="#/xhtml/002_titlehead#head-title" title="Link target outside of Sample">On the Head of a Pin</span></p>
<p class="toc-bot"><span href="#/xhtml/002_beginreading#beread" title="Link target outside of Sample">Begin Reading</span></p>
<p class="toc"><span href="#/xhtml/002_adcard#adc" title="Link target outside of Sample">Also by Walter Mosley</span></p>
<p class="toc"><span href="#/xhtml/002_atauthor#ata" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/002_copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_contents.vue?5cf64b7e